import { ReactNode } from 'react';
import { getHighlightedTextParts } from './utils';

export const HighlightedMessageText = ({
  text,
  highlight,
  fallback,
}: {
  text?: string;
  highlight?: string;
  fallback?: ReactNode;
}) => {
  if (!text) return fallback;
  if (!highlight) return text;

  const { before, match, after } = getHighlightedTextParts(text, highlight);

  if (!match) return text;

  return (
    <>
      {before}
      <mark className="bg-yellow-200 text-gray-900 rounded-[2px] font-medium">{match}</mark>
      {after}
    </>
  );
};
